import React, { useEffect, useState } from 'react';
import { Chip, Tooltip } from '@mui/material';
import { Circle } from '@mui/icons-material';
import wsService from '../services/websocket';

/**
 * Small "Live / Offline" indicator for the WebSocket connection.
 * Self-contained — subscribes to wsService's 'connection' event and
 * tracks the latest status. Safe to drop into any page header.
 */
function WebSocketBadge({ sx }) {
  const [connected, setConnected] = useState(() => wsService.isConnected());

  useEffect(() => {
    const remove = wsService.addEventListener('connection', (data) => {
      setConnected(data.status === 'connected');
    });
    // Re-check right after mount in case the connection state changed
    // between the initial useState and the effect binding.
    setConnected(wsService.isConnected());
    return remove;
  }, []);

  return (
    <Tooltip
      title={connected
        ? 'Real-time WebSocket connected — UI receives live pushes'
        : 'WebSocket disconnected — data may be stale; client is attempting to reconnect'}
      arrow
    >
      <Chip
        icon={<Circle sx={{ fontSize: 8, color: connected ? 'success.main' : 'error.main' }} />}
        label={connected ? 'Live' : 'Offline'}
        size="small"
        variant="outlined"
        sx={{
          fontSize: '0.7rem',
          height: 22,
          color: connected ? 'success.main' : 'error.main',
          borderColor: connected ? 'success.main' : 'error.main',
          '& .MuiChip-label': { px: 0.75 },
          ...sx,
        }}
        aria-label={connected ? 'WebSocket connected' : 'WebSocket disconnected'}
      />
    </Tooltip>
  );
}

export default WebSocketBadge;
